import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import CartPopup from '../Components/CartPopup';
import WishlistPopup from '../Components/WishlistPopup';
import NotificationRequestPopup from '../Components/NotificationRequestPopup';
//import NewsletterPopup from '../Components/NewsletterPopup';
import Item from '../Components/Item/Item';
import WishlistIcon from '../Components/WishlistIcon';
import ItemBreadcrumb from '../Components/Breadcrumb/ItemBreadcrumb';
import Slideshow from '../Components/SlideshowAw/Slideshow';
import ItemIcon from '../Components/Item/ItemIcon';
import ItemDetailSnippet from '../Components/RichSnippet/ItemDetailSnippet';
//import ItemSnippet from '../Components/RichSnippet/ItemSnippet';
//import AuthContext from "../store/auth-context";

function ProductDetail(props) {
  //const authCtx = useContext(AuthContext);
  const params = useParams();
  //const history = useHistory();
  const [IsLoading, setIsLoading] = useState(false);
  const [NetError, setNetError] = useState(null);
  const [netError, setnetError] = useState(null);

  //const location = useLocation();
  const [AddToCart, setAddToCart] = useState(false);
  const [ToggleWishlist, setToggleWishlist] = useState(false);  // per far apparire il dialog in caso l'utente sia non loggato
  const [NotifyAvailability, setNotifyAvailability] = useState(false);

  const itemId = params.itemId;
  const { isLoading, isError, data, error } = useQuery(
    ["fetchProduct", itemId, props.token],
    () => fetchProductDetails(itemId, props.token)
  );
  const ItemData = data;

  useEffect(() => {
    //if (NotifyAvailability === false && ToggleWishlist === false && AddToCart === false)
    window.scrollTo(0, 0);
  }, [params.itemId]); // sempre, non solo la prima volta

  let preferito = false;
  if (props.wishlist) {
    preferito =  (props.wishlist.id_e_produtcs_list.indexOf(itemId) > -1 )
  }


  const slideCfg = {
    sideThumbnail: "left" /* left, right, none */,
    thumbArrows: false,
    rowThumbImg: false, /* se true, usa le immagini per le thumbnail orizzontali */
    rowThumbDot: false, /* se vero, usa i pallini per le thumbnail orizzontali */
    rowThumbCompact: true, /* se vero, usa il formato 'compact' per le thumbnail orizzontali */
    //mediaClause: "(max-width: 919px)", /* clausola delle media query che discrimina tra desktop mode e mobile mode*/
    mediaClause: props.cfg.mediaClause, /* clausola delle media query che discrimina tra desktop mode e mobile mode*/
  };
/*
  async function fetchProductDetails(productId) {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + props.token.access_token);

      var formdata = new FormData();
      formdata.append("id_e_products", productId.toString());

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };
      const response = await fetch(
        "https://ws.mediatoys.it/product/productDetail",
        requestOptions
      );
      if (!response.ok) {
        if (response.status === 401) {
          // check error message???
          console.log("TOKEN UPDATE!");
          props.tokenUpdate();
        }
        throw new Error("Network error " + response.status);
      }
      const payload = await response.json();
      console.log("fetchProductDetails() Ok");
      //console.log(payload);
      if (payload.length > 0) {
        console.log(payload[0]);
        return payload[0];
      } else {
        //setItemData(null);
        throw new Error("Articolo non trovato ");
      }
    } catch (error) {
      console.log(error.message);
      //setNetError(error.message);
      throw new Error(error.message);
    }
  }
*/
async function fetchProductDetails(productId, token) {
  try {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token.access_token);
    //console.log("fetchProductDetails: using token "+props.token.access_token);

    var formdata = new FormData();
    formdata.append("id_e_products", productId.toString());

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    const response = await fetch(
      "https://ws.mediatoys.it/product/productDetail",
      requestOptions
    );
    if (!response.ok) {
      if (response.status === 401) {
        // check error message???
        //console.log("TOKEN UPDATE!");
        props.tokenUpdate();
        //console.log("Invalidate Query!");
        //props.qc.invalidateQueries("fetchProduct", productId, props.token);
      }
      throw new Error("Network error " + response.status);
    }
    const payload = await response.json();
    if (props.cfg.debug === true) 
      console.log("fetchProductDetails() Ok");
    //console.log(payload);
    if (payload.length > 0) {
      if (props.cfg.debug === true) 
        console.log(payload[0]);
      return payload[0];
    } else {
      //setItemData(null);
      throw new Error("Articolo non trovato ");
    }
  } catch (error) {
    console.log(error.message);
    //setNetError(error.message);
    throw new Error(error.message);
  }
}

  function addToCartHandler(productId, qty=1) {
    let params = [
      {name: "session", value: props.sessionKey},
      {name: "id_utente", value: props.userData? props.userData.id_e_user.toString() : "0"},
      {name: "id_e_products", value: productId.toString()},
      {name: "id_e_products_models", value: "0"},
      {name: "quantita_carrello", value: qty.toString()}
    ];
    props.wsCall("https://ws.mediatoys.it/carrello/add", IsLoading, setIsLoading, NetError, setNetError, params, (respData) => {
      props.cartUpd(respData.data);
      setAddToCart(true);
    });    
  }

async function toggleWishListHandler(productId, flag) {
  if (props.userData && props.userData.id_e_user.length > 0) {
      //console.log("CLICCATO PREFERITI!");
      let params = [
        {name: "id_e_user", value: props.userData? props.userData.id_e_user.toString() : "0"},
        {name: "id_e_products", value: productId.toString()},
      ];
      props.wsCall("https://ws.mediatoys.it/cliente/add_del_prodotto_preferiti", IsLoading, setIsLoading, netError, setnetError, params, (respData) => {
        //props.cartUpd(respData.data);
        //setAddToCart(true);
        props.setWishlist(respData);
        //console.log(respData);
      })

    } else {
      setToggleWishlist(true);  
    }
}
/*
function convert(num) {
  return num.toFixed(2).replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}
*/
function manageItemList() {
  if (
    ItemData != null &&
    ItemData.correlati != null &&
    ItemData.correlati.data != null &&
    ItemData.correlati.data.length > 0
  ) {
    return (
      <div className="contenitore_consigliati">
        <div className="titolo_consigliati">
          <h3>{ItemData.correlati.label}</h3>
        </div>
        <div className="torri_consigliati">
          {ItemData.correlati.data.map((item, i) => (
            <Item
              key={"itc_" + item.id_e_products}
              item={item}
              urlImg={props.cfg.urlItemImg}
              click={addToCartHandler}
              toggle={toggleWishListHandler}
              wishlist={props.wishlist}
              convert={props.cfg.convert}
              catalogSlug={props.cfg.catalogSlug}              
            />
          ))}
        </div>
      </div>
    );
  } else {
    return null;
  }
}

  function closeCartDialog() {
    setAddToCart(false);
  }

  function closeWishlistDialog() {
    setToggleWishlist(false);
  }

  function closeNotificationDialog() {
    setNotifyAvailability(false);
  }

  function itemDescr() {
    return { __html : ItemData.descrizione};
  }

  function showPrice() {
    if (!ItemData) 
      return null;

    if (ItemData.prezzo_listino !== ItemData.prezzo_b2c)
      return (
        <h3>
          &euro; {props.cfg.convert(ItemData.prezzo_b2c)}
          <span className="barrato">&euro; {props.cfg.convert(ItemData.prezzo_listino)}</span>
        </h3>
      );
    else 
      return <h3>&euro; {props.cfg.convert(ItemData.prezzo_listino)}</h3>;
  }

  //console.log(ItemData);
  let categoryName = "";
  let categorySlug = "";
  let scaleName = "";
  let category = {};
  if (ItemData && ItemData.category && ItemData.category.length > 0) {
    category = ItemData.category.find(el => el.livello && el.livello === "2");
    if (!category) {
      category = {
        nome: "burago",
        slug: "burago",
        id_category_list: "5",
      }        
    }
    categoryName = category.nome;
    categorySlug = category.slug;
  }
  if (ItemData && ItemData.scala && ItemData.scala.length > 0) {
    scaleName = ItemData.scala[0].nome;
  }

  if (!ItemData) {
    return (
      <>
        {isLoading === true ? (
          <div className="spinner" >
            <img src="/images/waiting.gif" alt="loading..." />
          </div>
        ) : null}

        {isError && error !== null? <p>{error.message}</p> : null}
      </>
    );
  }
  
  return (
    <>
      {AddToCart === true ? (
        <CartPopup
          titletext="Congratulazioni!"
          text="Articolo aggiunto al carrello"
          closeHandler={closeCartDialog}
        />
      ) : null}
      {ToggleWishlist === true ? (
        <WishlistPopup
          titletext=""
          text=""
          closeHandler={closeWishlistDialog}
        />
      ) : null}
      {NotifyAvailability === true ? (
        <NotificationRequestPopup
          itemId={ItemData.id_e_products}
          token={props.token}
          sessionKey={props.sessionKey}
          tokenUpdate={props.tokenUpdate}
          wsCall={props.wsCall}
          closeHandler={closeNotificationDialog}
          userEmail={props.userData !== null ? props.userData.mail : ""}
          privacyUrl={props.cfg.iubendaPrivacyUrl}
        />
      ) : null}

      {IsLoading === true ? (
        <div className="spinner">
          <img src="/images/waiting.gif" alt="loading..." />
        </div>
      ) : null}

      {NetError ? <p>{NetError}</p> : null}

      <div className="contenitore_01">
        <div className="contenuto_01 sfondo_01">
          <ItemBreadcrumb
            itemId={ItemData.id_e_products}
            itemTitle={ItemData.nome}
            itemSlug={ItemData.slug}
            categoryId={category.id_category_list}
            categoryTitle={categoryName}
            categorySlug={categorySlug}
            catalogText={props.cfg.catalogText}
            catalogSlug={props.cfg.catalogSlug}        
                //crumb={props.from}
            //pos={props.pos}
          />

          <div className="riga_01">
            <div className="articolo_main">
              <Slideshow
                images={ItemData.images}
                //videos={ItemData.videos}
                videos={[]}
                //new={ItemData.FGNovita === "VERO" ? true : false}
                new={false}
                //inEvidence={ItemData.FGInEvidenza === "VERO" ? true : false}
                inEvidence={false}
                cfg={slideCfg}
                //urlBase={props.cfg.urlItemImg}
                urlBase=""
              />

              <section className="descrizione_articolo">
                <h1>{ItemData.nome}</h1>
                <h2>
                  <span>Codice:</span>
                  {ItemData.codice}
                </h2>
                <h3>
                  {
                    //ItemData.DSSottotitolo_It
                    scaleName
                  }
                </h3>

                <div className="prezzo_articolo">{showPrice()}</div>

                {ItemData.sconto_calcolato > 0 ? (
                  <div className="ico-dettaglio_sconto">
                    <p>-{props.cfg.convert(ItemData.sconto_calcolato)}%</p>
                  </div>
                ) : null}

                <div className="dettaglio_articolo_note">
                  {!ItemData || !ItemData.label
                    ? null
                    : ItemData.label.map((el, i) => (
                        <ItemIcon
                          key={"itl_" + i}
                          cssClass={"dettaglio_articolo_nota" + el.code}
                          text={el.value}
                          fg={true}
                        />
                      ))}
                </div>

                {props.cfg.htmlItemDescr === true ? (
                  <div dangerouslySetInnerHTML={itemDescr()} />
                ) : (
                  <p className="dettaglio_articolo_descrizione">{ItemData.descrizione}</p>
                )}

                {ItemData.vendibile === "1" ? (
                  <input
                    type="button"
                    className="bottone_01"
                    value="Aggiungi al carrello"
                    onClick={(e) => addToCartHandler(ItemData.id_e_products)}
                  />
                ) : (
                  <div className="dettaglio_articolo_non_disponbile">
                    <p>
                      Prodotto al momento non acquistabile.
                      <br />
                      Se vuoi essere avvisato non appena è disponibile{" "}
                      <span
                        className="dettaglio_articolo_richiedi_avviso"
                        onClick={() => setNotifyAvailability(true)}
                      >
                        clicca qui
                      </span>
                      .
                    </p>
                  </div>
                )}

                <WishlistIcon
                  //on={ItemData.FGWishlist}
                  on={preferito}
                  id={ItemData.id_e_products}
                  toggle={toggleWishListHandler}
                />
              </section>
              <div className="clear"></div>
            </div>
          </div>
          <div className="clear"></div>

          {manageItemList()}

          <div className="clear"></div>
        </div>
      </div>

      <ItemDetailSnippet
        item={ItemData}
        categoryId={category.id_category_list}
        categoryName={categoryName}
        categorySlug={categorySlug}
        //catalogText={props.cfg.catalogText}
        catalogSlug={props.cfg.catalogSlug}        
        urlBase={props.cfg.urlBase}
      />
      <div className="clear"></div>
    </>
  );
}

export default ProductDetail;